<form [formGroup]="phoneForm">
  <ngx-intl-tel-input
    class="phone-number"
    [preferredCountries]="['us']"
    [selectedCountryISO]="selectedCountryISO"
    [cssClass]="'ds-input-black' + (notValid || (phoneForm?.controls?.phone?.touched && !validForm) ? ' error' : '')"
    [enablePlaceholder]="true"
    [enableAutoCountrySelect]="true"
    [searchCountryFlag]="true"
    [selectFirstCountry]="false"
    [maxLength]="30"
    [phoneValidation]="true"
    (countryChange)="onCountryChange($event)"
    name="phone"
    formControlName="phone">
  </ngx-intl-tel-input>
<!--  <span *ngIf="(phoneForm?.controls?.phone?.touched && !validForm)" class="ds-input-error-msg"
        [innerHTML]="'text_invalidRedirectFrom' | dbText"></span>-->
</form>

